// extracted by mini-css-extract-plugin
module.exports = {"ratingBtn":"RatingOption_ratingBtn__1gFUr","ratingBtnDisplay":"RatingOption_ratingBtnDisplay__3AG9i"};